import toastr from "toastr";
import bootbox from "bootbox";

const Alert = toastr;
Alert.options = {
  escapeHtml: true,
  positionClass: "toast-top-center",
  timeOut: 0,
  extendedTimeOut: 0,
  closeButton: true,
};
const Modal = bootbox;
export { Alert, Modal };
